import React, { Component } from 'react';

import firebase from './firebase';
import firebaseui from 'firebaseui';

import {getQueryVariable} from './history';

class FirebaseAuthContainer extends Component {
  componentDidMount() {
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        document.location=getQueryVariable("next") || '/account';
      } else {
        // FirebaseUI config.
        var uiConfig = {
          signInSuccessUrl: getQueryVariable("next") || '/account',
          signInOptions: [
            // Leave the lines as is for the providers you want to offer your users.
            firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
            // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
            // firebase.auth.GithubAuthProvider.PROVIDER_ID,
            // firebase.auth.EmailAuthProvider.PROVIDER_ID
          ],
          // Terms of service url.
          tosUrl: '<your-tos-url>'
        };

        // Initialize the FirebaseUI Widget using Firebase.
        var ui = new firebaseui.auth.AuthUI(firebase.auth());
        // The start method will wait until the DOM is loaded.
        ui.start('#firebaseui-auth-container', uiConfig);
      }
    }, function(error) {
      console.log(error);
      document.getElementById('sign-in-status').textContent = error;
    });
  }

  render() {
    return (
      <div>
        <div id="sign-in-status"></div>
        <div id="firebaseui-auth-container"></div>
      </div>
    )
  }
}

class LoginPage extends Component {
  render() {
    return (
      <div style={{
          backgroundColor: "white"
        }}>
         <div className="LoginPage"
              style={{
                width: '400px',
                margin: 'auto',
                textAlign: "center",
                boxShadow: "1px 1px 3px #c2c2c2",
                backgroundColor: "#fafafa",
                color: "#728099",
              }}>

           <h3
             style={{
               padding: "16px",
             }}>
             Home Gallery Project
           </h3>
           <FirebaseAuthContainer />
           <div className="Help"
             style={{
               width: "100%",
               backgroundColor: "#efefef",
               marginTop: "16px",
               paddingTop: "16px",
               paddingBottom: "16px"
             }}>
             Need Help? Email help@homegalleryproject.com
           </div>
         </div>
      </div>
    );
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/LoginPage.js